import { useState, useCallback } from 'react'

/**
 * Hook to manage no overlapping GAM targeting per inventory per day validation state across the form
 * This tracks whether there are any targeting conflicts that would prevent form submission
 */

export const useNoOverlappingGamTargetingValidationState = () => {
  const [validationState, setValidationState] = useState({
    isValid: true,
    errors: []
  })

  const updateValidationState = useCallback(validationResult => {
    setValidationState(validationResult)
  }, [])

  return {
    validationState,
    updateValidationState,
    hasTargetingConflicts: !validationState.isValid && validationState.errors.length > 0
  }
}

export default useNoOverlappingGamTargetingValidationState
